<script lang="ts" setup>
import A11yDialog from "a11y-dialog";
import { onMounted, ref } from "vue";

import CloseDialogButton from "./CloseDialogButton.vue";

const dialogElementRef = ref(null);

let dialog: A11yDialog | null = null;

onMounted(() => {
  const protocolDialogContainer = dialogElementRef.value;

  if (protocolDialogContainer) {
    dialog = new A11yDialog(protocolDialogContainer);
  }
});

defineExpose({ getDialog: () => dialog });
</script>

<template>
  <div class="dialog">
    <div
      id="ref-dialog"
      ref="dialogElementRef"
      aria-describedby="dialog-description"
      aria-hidden="true"
      aria-labelledby="dialog-title"
      class="dialog-container"
    >
      <div class="dialog-overlay" data-a11y-dialog-hide></div>

      <div class="dialog-content" role="document">
        <CloseDialogButton></CloseDialogButton>

        <h1 id="dialog-title" class="title">
          <slot name="title"></slot>
        </h1>

        <hr class="break-free" />

        <p id="dialog-description">
          <slot name="description"></slot>
        </p>

        <slot name="body"></slot>
      </div>
    </div>
  </div>
</template>

<style scoped>
.title {
  font-size: 4rem;
  font-weight: bold;
}

.break-free {
  margin-inline: -2rem;
}

#ref-dialog {
  z-index: 10;
}

.dialog-container,
.dialog-overlay {
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
}

.dialog-container {
  display: flex;
  z-index: 2;
}

.dialog-container[aria-hidden="true"] {
  display: none;
}

.dialog-overlay {
  animation: fade-in 200ms both;
  background-color: #2b2e38e6;
}

.dialog-content {
  background-color: white;
  margin: auto;
  position: relative;
  z-index: 2;

  animation: fade-in 400ms 200ms both, slide-up 400ms 200ms both;
  border-radius: 5px;
  max-width: 90%;
  padding: 0.5em;
  width: clamp(700px, 55dvw, 80%);
}

@media screen and (min-width: 700px) {
  .dialog-content {
    padding: 2em;
  }
}

@keyframes fade-in {
  from {
    opacity: 0;
  }
}

@keyframes slide-up {
  from {
    transform: translateY(10%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .dialog-overlay,
  .dialog-content {
    animation: none;
  }
}

.dialog-content h1 {
  font-size: 1.25em;
  margin: 0;
}
</style>
